import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const SignIn = () => {
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [validEmail, setValidEmail] = useState("email");
    const [validPwd, setValidPwd] = useState("pass");

    const validateData = () => {
        let valid = false;
        if (email === "") {
            setValidEmail(email);
            valid = true;
        }
        if (password === "") {
            setValidPwd(password);
            valid = true;
        }
        return valid;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validateData()) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, { email, password });
                if (response.data.status === "success") {
                    localStorage.setItem(
                        "signIn",
                        response.data.token
                    );
                    toast.success(response.data.message);
                    navigate("/manage-key-person");
                }
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }
    };
    return (
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                        <div className="card mb-3">
                            <div className="card-body">
                                <div className="pt-3 pb-2">
                                    <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
                                    <p className="text-center small">Enter your username & password to login</p>
                                </div>
                                <form className="row g-3" onSubmit={handleLogin}>
                                    <div className="col-12">
                                        <label className="form-label">Username</label>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className={`form-control ${validEmail === '' && 'is-invalid'}`}
                                                onChange={(e) => {
                                                    setEmail(e.target.value);
                                                    setValidEmail(e.target.value)
                                                }}
                                            />
                                            {validEmail === '' && <div className="invalid-feedback">
                                                Email is required
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label">Password</label>
                                        <input
                                            type="password"
                                            className={`form-control ${validPwd === '' && 'is-invalid'}`}
                                            onChange={(e) => {
                                                setPassword(e.target.value);
                                                setValidPwd(e.target.value)
                                            }}
                                        />
                                        {validPwd === '' && <div className="invalid-feedback">
                                            Password is required
                                        </div>}
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-primary w-100" type="submit">
                                            Login
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SignIn;
